import {
	buildPageStaggerIndexMap,
	shouldApplyStaggerPageElementTransition,
} from "./erPageStaggerUtils";

export { buildPageStaggerIndexMap as buildRevealStaggerIndexMap };

export function shouldApplyRevealPageElementTransition(ctx) {
	return shouldApplyStaggerPageElementTransition("reveal", ctx);
}

/** Ritmo más lento y cinematográfico que cómic/dispersión. */
function computeRevealPageStaggerTimings(durationMs, totalCount) {
	const total = Math.max(1, totalCount || 1);
	const baseMs = Math.max(1000, (Number(durationMs) || 550) * 1.55);
	const totalSec = baseMs / 1000;
	const panelSec = Math.max(0.62, totalSec * 0.62);
	const staggerSpan = Math.max(0, totalSec - panelSec);
	const stepSec = total > 1 ? staggerSpan / (total - 1) : 0;
	return { totalSec, panelSec, stepSec, delaySec: (index) => index * stepSec };
}

function revealTiltForElement(index, elementId) {
	const base = [-8, 6, -5, 7][index % 4];
	let hash = 0;
	const id = String(elementId ?? index);
	for (let i = 0; i < id.length; i += 1) hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
	return base + (Math.abs(hash) % 3) - 1;
}

/** Distancia de caída según posición vertical en el canvas. */
function revealDropForElement(element, canvasH = 540) {
	const y = Number(element?.y) || 0;
	const h = Number(element?.height) || 48;
	const drop = Math.min(260, Math.max(110, y * 0.62 + h * 0.45 + 95));
	return `${Math.round(drop)}px`;
}

export function getRevealPageTransitionElementStyle(staggerIndex, totalCount, durationMs, element) {
	const idx = Math.max(0, staggerIndex || 0);
	const { panelSec, delaySec } = computeRevealPageStaggerTimings(durationMs, totalCount);
	const tilt = revealTiltForElement(idx, element?.elementId);
	const drop = revealDropForElement(element);
	return {
		opacity: 0,
		transformOrigin: "center bottom",
		"--er-reveal-drop": `-${drop}`,
		"--er-reveal-tilt": `${tilt}deg`,
		animation: `er-page-reveal-panel ${panelSec}s cubic-bezier(0.34, 1.38, 0.52, 1) ${delaySec(idx)}s both`,
		willChange: "opacity, transform, filter",
	};
}

export function getRevealPageBackgroundStyle(durationMs) {
	const { totalSec } = computeRevealPageStaggerTimings(durationMs, 1);
	const sec = Math.max(0.55, totalSec * 0.72);
	return {
		opacity: 0,
		filter: "brightness(0.5) saturate(0.88)",
		animation: `er-page-reveal-bg ${sec}s ease-out both`,
		willChange: "opacity, filter",
	};
}
